export default __webpack_public_path__ + "static/media/80.153cc736.svg";